import { types } from '../../../../_constants/product/types';
import LightboxActions, { openAction as openCarFittingStationFinder } from '../../../actions/lightbox_actions';
import { FsfPages } from '../../../../_constants/fsf_pages';
import ActiveStationStore from '../../../stores/active_station_store';
import parseGoogleLatLng from '../../../helper/parse_google_lat_lng';
import MapStore from '../../../stores/map_store';
import { FittingStationStore } from '../../../stores/fitting_station_store';
import { loadStations } from '../../../../_modules/fitting_station/load_stations';
import FittingStationFinderConstants from '../../../constants/fitting_station_finder_constants';
import { showAction as openMotoFittingStationFinder } from '../../../actions/fsf_moto_light_box_actions';
import { getPostcodeFromLocalStorage } from '../../../../utilities/local_storage';
import { loadGoogleMapDependencies } from '../../../../_global/initGoogleMapDependencies';
import { CrossSellProductStore } from '../../../stores/cross_sell_product_store';

let crossSellPreselectedPersistValues = [];
const onChangeStationClick = (productType) => {
    loadGoogleMapDependencies();
    TYROOLA.mapsInitiated.then(() => {
        if (productType === types.TYRE_CAR) {
            LightboxActions.totalPagesChangeAction(FsfPages.WITH_SUCCESS_NOTIFICATION);
            const appliedPostcode = ActiveStationStore.getState().activeStation.postcode;
            const latLng = parseGoogleLatLng(MapStore.getState().latLng);
            if (typeof latLng.lat !== 'undefined'
                && typeof latLng.lng !== 'undefined'
                && null !== appliedPostcode) {
                let stations = FittingStationStore.getState().stations;
                const hasCrossSellProducts = CrossSellProductStore.getState();
                const crossSellPreselectedValues = hasCrossSellProducts.map(csp => ({ preselected: csp.preselected }));
                
                if (stations.length <= 0 || JSON.stringify(crossSellPreselectedPersistValues) !== JSON.stringify(crossSellPreselectedValues)) {
                    // TODO: here the postcode is set from the active station on cart page
                    // loadStations(appliedPostcode);
                    crossSellPreselectedPersistValues = [...crossSellPreselectedValues];
                    loadStations(getPostcodeFromLocalStorage());
                }
                LightboxActions.openAction();
                LightboxActions.goToPageAction(FittingStationFinderConstants.LIGHTBOX_PAGE_FINDER);
            }

            openCarFittingStationFinder();
        }
        if (productType === types.TYRE_MOTO) {
            openMotoFittingStationFinder();
        }
    });
};

export default onChangeStationClick;